/* eslint-disable spaced-comment,func-names,object-shorthand */
import React from 'react';
import request from 'superagent';
import Highcharts from 'highcharts';
import Highstock from 'highcharts/highstock';
import Chart from "../Chart";
import API from '../../../config/API';
import {getDataFilesCacheVersion} from "../../../helpers/cache";

require('highcharts-more')(Highstock);
require('highcharts/modules/exporting')(Highstock);
require('highcharts/modules/export-data.src')(Highstock);
const ReactHighcharts = require('react-highcharts/ReactHighstock').withHighcharts(Highstock);

class AverageTradeSize extends Chart {

    componentDidMount() {
        request.get(API.getHost('data').concat(getDataFilesCacheVersion('/data-feeds/charts/MarketInsights/avg_trade_size_usa.csv'))).then(data => {

            const options = {
                //chart options
                chart: {
                    //set type of graph, where it renders
                    type: 'line',
                    renderTo: 'avg_trade_size_usa_container',
                    height: 600,
                    style: {
                        fontFamily: 'Exo'
                    }
                },
                //set title of graph
                title: {
                    text: 'TRACE Average Trade Size',
                    style: {
                        color: '#4D759E'
                    },
                    align: 'center'
                },
                //set xAxis title
                xAxis: {
                    title: {
                        text: 'Date',
                        style: {
                            color: '#4D759E',
                            fontWeight: 'bold'
                        }
                    }
                },
                //set yAxis info
                yAxis: {
                    title: {
                        text: 'TRACE Average Trade Size ( Thousands USD )',
                        style: {
                            color: '#4D759E',
                            fontWeight: 'bold'
                        }
                    },
                    labels: {
                        //give y-axis labels commas for thousands place seperator
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, '', ',');
                        }
                    },
                    //set y-axis to the left side
                    opposite: false,
                    //set background grid line width
                    gridLineWidth: 1
                },
                //stylize the tooltip
                tooltip: {
                    pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
                    valuePrefix: '$',
                    valueDecimals: 2
                },
                //enable and stylize the legend
                legend: {
                    enabled: true,
                    layout: 'horizontal',
                    align: 'center',
                    borderWidth: 1,
                    borderRadius: 5,
                    itemDistance: 20,
                    reversed: false
                },
                //set the starting range. 0-5. 5="All", 4="1yr", etc
                rangeSelector: {
                    selected: 4,
                    allButtonsEnabled: true
                },
                //set general plot options
                plotOptions: {},
                //disable credits
                credits: {
                    enabled: false
                },
                //make download as csv format correctly
                navigator: {
                    series: {
                        includeInCSVExport: false
                    }
                },
                //set name of chart downloads
                exporting: {
                    filename: 'MarketAxess_avg_trade_size_usa',
                    //enable download icon
                    enabled: true,
                    //add image to download
                    chartOptions: {
                        chart: {
                            events: {
                                load: function () {
                                    this.renderer.image('/public/images/charts/marketaxess_logo2.gif', 90, 75, 300, 48).attr({
                                        opacity: 0.1
                                    }).add();
                                }
                            }
                        },
                        //remove scrollbar and navigator from downloaded image
                        scrollbar: {
                            enabled: false
                        },
                        navigator:{
                            enabled: false
                        }
                    },
                    //make download as csv format correctly
                    csv: {
                        dateFormat: '%Y-%m-%d'
                    }
                },
                //set graph colors
                colors: [
                    '#1D5B7F',
                    '#76b34d',
                    '#636569',
                    '#6786B8',
                    '#8244FF',
                    '#848486',
                    '#a42a47',
                    '#f8dc32',
                    '#2a84b9',
                    '#91c271',
                    '#818388',
                    '#8598c6',
                    '#cd3d60',
                    '#f6e35b',
                    '#11374c',
                    '#476c2e',
                    '#3b3d3f',
                    '#374f75',
                    '#621903',
                    '#ad9506'
                ],
                //series to be filled by data
                series: []
            };

            //names of labels in order of series. make sure they are the same as series header in data file
            const names = ['HG','HG &gt; 100K', 'HY', 'HY &gt; 100K'];
            //get csv file, multiply by 100 (divide by .01) and populate chart
            this.readCSV(options, data.text, 1000, names);

            this.setState({options});
        });
    }

    render() {
        if (!this.state.options) return null;

        return(
            <div className="container">
                <ReactHighcharts config={this.state.options}/>
            </div>
        );
    }
}

export default AverageTradeSize;



// WEBPACK FOOTER //
// ./frontend/components/Charts/MarketInsights/AverageTradeSize.jsx